"use strict";
const i18nConfig = {
    locales: ['en', 'zh', 'ja'],
    defaultLocale: 'ja',
    localeDetector: () => {
        return 'ja';
    },
};
module.exports = i18nConfig;
//# sourceMappingURL=index.js.map